import React from 'react';
import { BudgetSummaryStatus } from 'src/types/budget-summary-status.enum';
import styles from './spentRemaining.module.scss';
import FormatService from 'src/services/format.service';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';
import { getTrackerStatus } from 'src/utils/budget.utils';

interface SpentRemainingProps {
    spentAmount: number;
    budgetAmount: number;
    isMinWidthSmall?: boolean;
}
export default function SpentRemaining({
    spentAmount,
    budgetAmount,
    isMinWidthSmall
}: SpentRemainingProps): JSX.Element {
    const status: BudgetSummaryStatus = getTrackerStatus(spentAmount, budgetAmount);
    const remainingAmount: number = budgetAmount - spentAmount;

    const statusClassName: string =
        status === BudgetSummaryStatus.OVER
            ? styles.bad
            : status === BudgetSummaryStatus.AT_RISK
            ? styles.warning
            : styles.good;

    const formattedAmount: string = FormatService.formatCurrency(
        remainingAmount < 0 ? remainingAmount * -1 : remainingAmount
    );

    return (
        <span
            data-cy={Selectors.SpendSmart.SPENT_REMAINING}
            className={isMinWidthSmall ? styles.spentRemainingPill : styles.spentRemainingText}
        >
            <Typography variant={TypographyVariants.LEGAL_PRIMARY}>
                {LiteralsService.getLiteral(`SpentRemaining.${remainingAmount < 0 ? 'exceeding' : 'remaining'}`)}
            </Typography>
            <Typography
                variant={TypographyVariants.LEGAL_SECONDARY}
                className={`${
                    isMinWidthSmall ? styles.progressAmountPill : styles.progressAmountText
                } ${statusClassName}`}
                data-cy={Selectors.SpendSmart.AMOUNT_REMAINING_PILL}
            >
                {formattedAmount}
            </Typography>
        </span>
    );
}
